import { render, staticRenderFns } from "./WhatLook.vue?vue&type=template&id=f38f0d4e&scoped=true&lang=pug&"
import script from "./WhatLook.vue?vue&type=script&lang=js&"
export * from "./WhatLook.vue?vue&type=script&lang=js&"
import style0 from "./WhatLook.vue?vue&type=style&index=0&id=f38f0d4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38f0d4e",
  null
  
)

export default component.exports